import { Pipe, PipeTransform } from '@angular/core';
import { UliActivityType } from '../../constants';
import { ActiveCompartmentsModel } from '../../../store/state/monitoring/allocation-view';

@Pipe({
    name: 'filterCompartmentsByType',
    standalone: false
})
export class UliFilterCompartmentsByTypePipe implements PipeTransform {
  transform(compartments: ActiveCompartmentsModel[], type: UliActivityType): ActiveCompartmentsModel[] {
    return compartments?.filter((item: ActiveCompartmentsModel) =>
      type === UliActivityType.Outbound ? item.out : item.in,
    );
  }
}
